const positiveCreditDataAgreed = (value) => value === '1';
export default positiveCreditDataAgreed;
